import { Component } from '@angular/core';
import { IonicPage, ViewController } from 'ionic-angular';
import { AppConfig } from '../../../app/app.config';

@IonicPage()
@Component({
  selector: 'page-daily-log-modal',
  templateUrl: 'daily-log-modal.html',
})
export class DailyLogModalPage {

  config = AppConfig.settings;

  constructor(
    public viewController: ViewController,
  ) {

  }

  closeModal() {
    this.viewController.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/daily-log/daily-log-modal/daily-log-modal.ts